import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuGre = () => {
  const [isOpen, setIsOpen] = useState(false)
        
       const toggle = () => {
        setIsOpen(!isOpen)
       }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
           <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            KALLA GREKISKA MEZE
                        </div><br /><br />
                        <div className='menu_mat'>
                            Hummus med tahini, citron & extra virgin olivolja.
                            <br /><br />
                            Tzatziki med grekisk yoghurt, gurka, vitlök & färska örter.
                            <br /><br />
                            Melitzanosalata – grillad aubergine med vitlök & citron.
                            <br /><br />
                            Taramosalata – klassisk grekisk fiskromsröra.
                            <br /><br />
                            Fava – krämig gul ärtröra med karamelliserad lök & olivolja.
                            <br /><br />
                            Dolmadakia – vinblad fyllda med ris, örter & citron.
                            <br /><br />
                            Marinerad fetaost med olivolja, oregano & chili.
                            <br /><br />
                            Kalamataoliver & gröna oliver.
                            <br /><br />
                            Marinerade kronärtskockor.
                            <br /><br />
                            Grillad paprika & zucchini.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            GREKISKA PREMIUMSALLADER
                      </div><br /><br />
                      <div className='menu_mat'>
                        Horiatiki – klassisk grekisk sallad med tomat, gurka, rödlök, Kalamataoliver & fetaost.
                        <br /><br />
                        Ruccolasallad med fikon, valnötter & fetaost.
                        <br /><br />
                        Rostad rödbetssallad med chèvre, valnötter & honung.
                        <br /><br />
                        Grekisk potatissallad med färska örter, kapris & citron.
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                        GREKISK OST & DELIKATESSER
                        </div><br /><br />
                    <div className='menu_mat'>
                        Feta PDO.
                        <br /><br />
                        Graviera.
                        <br /><br />
                        Manouri.
                        <br /><br />
                        Halloumi.
                        <br /><br />
                        Färska fikon & vindruvor.
                        <br /><br />
                        Honung.
                        <br /><br />
                        Valnötter.
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        HAVETS DELIKATESSER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Kallrökta räkor med citron & färska örter.
                            <br /><br />
                            Marinerade bläckfiskringar med citron, persilja & olivolja.
                            <br /><br />
                            Räksallad med grekiska örter.
                            <br /><br />
                            Citronmarinerade musslor.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            GREKISKA VARMA SPECIALITETER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Souvlaki Kotopoulo -
                            Marinerade kycklingspett med citron, vitlök, oregano & olivolja.
                            <br /><br />
                            Keftedakia -
                            Saftiga grekiska köttbullar med färska örter & kryddor.
                            <br /><br />
                            Grillade lammkotletter -
                            Möra lammkotletter marinerade med vitlök, citron, oregano & grekiska örter.
                            <br /><br />
                            Moussaka -
                            Klassisk grekisk gratäng med aubergine, potatis, kryddad färs och krämig béchamelsås.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                VARMA TILLBEHÖR
                            </div><br /><br />
                        <div className='menu_mat'>
                            Grekisk citronpotatis med oregano.
                            <br /><br />
                            Rostade grönsaker med vitlök & färska örter.
                            <br /><br />
                            Spanakorizo – ris med spenat, citron & dill
                            Grillad zucchini & aubergine.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                GREKISKT BRÖD
                            </div><br /><br />
                            <div className='menu_mat'>
                                Färskt grekiskt lantbröd.
                                <br /><br />
                                Pita.
                                <br /><br />
                                Sesambröd.
                                <br /><br />
                                Olivolja & oregano.
                            </div>
                        </div>
                         <div className='card'>
                            <div className='meny_title'>
                                GREKISKA DESSERTER
                            </div><br /><br />
                            <div className='menu_mat'>
                                Baklava med pistage & valnöt.
                                <br /><br />
                                Galaktoboureko – filodeg med krämig vaniljkräm & citrussirap.
                                <br /><br />
                                Grekisk yoghurt med honung & valnötter.
                                <br /><br />
                                Loukoumades – små grekiska munkar med honung & kanel.
                                <br /><br />
                                Färska fikon & säsongens frukt.
                                <br /><br />
                            </div>
                        </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuGre